import { $Q, $Qll } from '../utils/query-selector';

const categoriesMenu = $Q('.categories-menu');
const categoriesMenuItems = $Qll('.categories-menu__item');
const categoriesMenuTitle = $Q('.categories-menu__title');
const categoriesblocks = $Qll('.categories-container');

/**
 * Start the event for the categories menu
 */
const initEventCategory = () => {
  if (!categoriesMenu) return;
  categoriesMenuItems.forEach(item => {
    item.addEventListener('click', showOrHideBlock);
  });

  showAllBlocks();
}

/**
 * This function is responsible for showing or hiding the FAQ blocks
 *
 * @param {Event} e Event of one of the items in the category menu
 */
const showOrHideBlock = (e) => {
  cleanCategories();
  categoryClicked(e);
  let dataHandle = e.target.classList.contains('categories-menu__item')
    ? e.target.dataset.handle
    : e.target.parentNode.dataset.handle;

  categoriesblocks.forEach((block) => {
    if (block.dataset.handle == dataHandle) {
      block.parentNode.style.display = 'block';

      let headerHeight = document.querySelector('header').offsetHeight;
      let topBar = document.querySelector('.top-bar').offsetHeight;

      let topBarOffset = 0;
      if ( topBar ) {
        topBarOffset = topBar;
      }
      let offsetScroll = block.parentNode.offsetTop - headerHeight - topBarOffset - 20;

      if (window.innerWidth <= 1260) {
        // Scroll function
        window.scrollTo({
          top: offsetScroll,
          behavior: "smooth",
        });
      }
    } else {
      block.parentNode.style.display = 'none';
    }
  });
}

/**
 * This function takes care of adding a class to the clicked element
 *
 * @param {*} e Event of one of the items in the category menu
 */
const categoryClicked = (e) => {
  e.target.classList.contains('categories-menu__item')
    ? e.target.classList.add('isClicked')
    : e.target.parentNode.classList.add('isClicked');
}

/**
 * This function is responsible for cleaning all the categories of the menu
 */
const cleanCategories = () => {
  categoriesMenuItems.forEach((e) => {
    e.classList.remove('isClicked');
  });
}

/**
 * This function is responsible for displaying all the FAQ blocks
 */
const showAllBlocks = () => {
  categoriesMenuTitle.addEventListener('click', () => {
    cleanCategories();
    categoriesblocks.forEach((block) => {
      block.parentNode.style.display = 'block';
    });
  });
}

initEventCategory();
